import React from 'react';
import { SWORN_DATA } from '../../gameData';
import { MorganaCorruption } from '../../types';
import { SelectionPanel } from '../ui/SelectionPanel';
import { SelectableItem } from '../ui/SelectableItem';
import { MorganaToggleOption } from '../ui/MorganaToggle';

interface MorganaPanelProps {
  mode: 'single' | 'double';
  setMode: (mode: 'single' | 'double') => void;
  selectedModifiers: string[];
  toggleModifier: (modifier: string) => void;
}

const MorganaPanel: React.FC<MorganaPanelProps> = ({
  mode,
  setMode,
  selectedModifiers,
  toggleModifier
}) => {
  const morganasCorruption = SWORN_DATA.morganas_corruption || [];
  const theme = SWORN_DATA.ui_assets?.morgana || { title_color: '#e6a84f', text_color: '#000000', selection_badge_color: '#e6a84f' };
  
  // Use either asset color or fallback to gold if undefined
  const primaryColor = theme.title_color || '#e6a84f';

  return (
    <SelectionPanel
      title="Morgana's Corruption"
      titleColor={primaryColor}
      toggleOptions={[{ label: 'Single Mod', value: 'single' }, { label: 'Double Mod', value: 'double' }] as [MorganaToggleOption<'single' | 'double'>, MorganaToggleOption<'single' | 'double'>]}
      toggleValue={mode}
      onToggleChange={setMode}
      toggleColors={{ primary: primaryColor, textOnPrimary: theme.text_color }}
      containerId="morgana-panel"
    >
      {morganasCorruption.map((c: MorganaCorruption) => {
        const selectionCount = selectedModifiers.filter(m => m === c.name).length;
        const isSelected = selectionCount > 0;

        return (
          <SelectableItem
              key={c.name}
              id={c.name}
              title={c.name}
              subtitle={c.effect}
              isSelected={isSelected}
              badgeText={mode === 'double' && selectionCount > 1 ? 'x2' : 'Active'}
              themeColor={theme.selection_badge_color}
              onClick={toggleModifier}
          />
        );
      })}
      {morganasCorruption.length === 0 && <div style={{ color: theme.text_color }}>No Morgana corruption data found.</div>}
    </SelectionPanel>
  );
};

export default MorganaPanel;
